module.exports = __webpack_public_path__ + "media/assets/img/home/home_img-dbe099582097d38c8a2e6f9f87345105.svg";